module.exports = __webpack_public_path__ + "img/konfigurasi_harga.da28755f.svg";